import debounce from "../helpers/debounce";

class NavItem {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.link = self.elem.querySelector('[data-nav-item-link]');
        self.dropdown = self.elem.querySelector('[data-nav-item-dropdown]');
        self.dropdownPrimaryItem = self.elem.querySelector('[data-nav-dropdown-primary-item]');
        self.header = document.querySelector('[data-header]');
        self.onOutsideClick = self.onOutsideClick.bind(self);
        self.onEscape = self.onEscape.bind(self);
        self.onScroll = self.onScroll.bind(self);
        self.isOpen = false;
    }

    init() {
        let self = this;
        
        self.link.addEventListener('click', evt => {
            evt.preventDefault();


            if(self.isOpen) {
                self.close();
            } else {
                self.open();
            }
        });
        
        // On click of the primary dropdown item...
        self.dropdownPrimaryItem.addEventListener('click', evt => {
            // If we are on mobile
            if(window.getComputedStyle(document.documentElement).getPropertyValue('--nav-style') == 'mobile') {
                // Prevent the default link action
                evt.preventDefault();

                // Close the sub-nav
                self.close();
            }
        });
        
    }

    open() {
        let self = this;
        self.dropdown.classList.add('is-visible');


        // Force a re-paint
        let reflow = self.dropdown.offsetHeight;

        self.elem.classList.add('is-open');



        self.link.setAttribute('aria-expanded', true);

        self.toggleHeaderClass();
        
        // Add event listeners
        self.addEventListeners();

        self.isOpen = true;


    }

    close() {
        let self = this;

        self.elem.classList.remove('is-open');

        // Function to remove is-visible class from dropdown element once slide transition is complete
        let func = function() {
            self.dropdown.classList.remove('is-visible');
            self.link.setAttribute('aria-expanded', false);
            self.dropdown.removeEventListener('transitionend', func);
        }

        //self.dropdown.addEventListener('transitionend', func, false);

        self.toggleHeaderClass();
        
        // Remove event listeners
        self.removeEventListeners();

        self.isOpen = false;
    }

    addEventListeners() {
        let self = this;

        // Start listening for clicks outside the dropdown
        document.addEventListener('click', self.onOutsideClick);

        // Start listening for escape key press
        document.addEventListener('keydown', self.onEscape);

        // Start listening for page scroll
        //document.addEventListener('scroll', self.onScroll);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for clicks outside the dropdown
        document.removeEventListener('click', self.onOutsideClick);

        // Stop listening for escape key press
        document.removeEventListener('keydown', self.onEscape);

        // Stop listening for page scroll
        //document.addEventListener('scroll', self.onScroll);
    }

    toggleHeaderClass() {
        let self = this;

        if(document.querySelectorAll('.is-open[data-module="nav-item"]').length > 0) {
            self.header.classList.add('nav-is-open');
        } else {
            self.header.classList.remove('nav-is-open');
        }
    }

    onOutsideClick(evt) {
        let self = this;

        // If we are on desktop
        if(window.getComputedStyle(document.documentElement).getPropertyValue('--nav-style') == 'desktop') {
            // If the click was not on the dropdown or its children
            if (evt.target !== self.dropdown && !self.dropdown.contains(evt.target) && evt.target !== self.link && !self.link.contains(evt.target)) {

                // Close the dropdown
                self.close();
            }
        }
    }

    onEscape(evt) {
        let self = this;

        if (evt.key === "Escape") {
            self.close();
        }
    }

    onScroll(evt) {
        let self = this;


        self.close();
    }
}

export default NavItem;